import * as echarts from "echarts";
import { useSelector } from "react-redux";
import {
  selectDashboardVehicleStatus,
  selectDashboardVehicleStatusError,
  selectDashboardVehicleStatusLoading,
} from "Redux/Dashboard/slice";
export const useVehicleStatus = () => {
  const vehicleStatus = useSelector(selectDashboardVehicleStatus);
  const loading = useSelector(selectDashboardVehicleStatusLoading);
  const error = useSelector(selectDashboardVehicleStatusError);

  const title = "Vehicle Status";

  const statuses = [
    {
      name: vehicleStatus.active && "Active",
      value: vehicleStatus.active?.count,
      color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: "#DF62AE80" }, // rgba(223, 98, 174, 0.5) -> #DF62AE80
        { offset: 0.9025, color: "#DF62AE26" }, // rgba(223, 98, 174, 0.15) -> #DF62AE26
      ]),
      itemStyle: { borderColor: "#DF62AE99" }, // rgba(223, 98, 174, 0.6) -> #DF62AE99
    },
    {
      name: vehicleStatus.inactive && "Inactive",
      value: vehicleStatus.inactive?.count,
      color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: "#007DF280" }, // rgba(0, 125, 242, 0.5) -> #007DF280
        { offset: 0.9025, color: "#007DF226" }, // rgba(0, 125, 242, 0.15) -> #007DF226
      ]),
      itemStyle: { borderColor: "#007DF2" }, // No transparency for border color
    },
    {
      name: vehicleStatus.out_of_service && "Out Of Service",
      value: vehicleStatus.out_of_service?.count,
      color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: "#FF8A01FF" }, // rgba(255, 138, 1, 1) -> #FF8A01FF
        { offset: 0.9025, color: "#FF8A014D" }, // rgba(255, 138, 1, 0.3) -> #FF8A014D
      ]),
      itemStyle: { borderColor: "#FF8A0199" }, // rgba(255, 138, 1, 0.6) -> #FF8A0199
    },
    {
      name: vehicleStatus.in_shop && "In Shop",
      value: vehicleStatus.in_shop?.count,
      color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: "#6F297B2E" }, // rgba(111, 41, 123, 0.18) -> #6F297B2E
        { offset: 0.9025, color: "#6F297B99" }, // rgba(111, 41, 123, 0.6) -> #6F297B99
      ]),
      itemStyle: { borderColor: "#6F297BFF" }, // rgba(111, 41, 123, 1) -> #6F297BFF
    },
    {
      name: vehicleStatus.downtime && "Downtime",
      value: vehicleStatus.downtime?.count,
      color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: "grey" }, // rgba(111, 41, 123, 0.18) -> #6F297B2E
        { offset: 0.9025, color: "grey" }, // rgba(111, 41, 123, 0.6) -> #6F297B99
      ]),
      itemStyle: { borderColor: "grey" }, // rgba(111, 41, 123, 1) -> #6F297BFF
    },
    {
      name: vehicleStatus.sold && "Sold",
      value: vehicleStatus.sold?.count,
      color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: "#FF8A00" }, // rgba(111, 41, 123, 0.18) -> #6F297B2E
        { offset: 0.9025, color: "#FF8A00" }, // rgba(111, 41, 123, 0.6) -> #6F297B99
      ]),
      itemStyle: { borderColor: "##FF8A00" }, // rgba(111, 41, 123, 1) -> #6F297BFF
    },
  ];
  return { statuses, loading, error, title };
};
